import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { DataTableOptimizedComponent } from 'src/app/shared/data-table-optimized/data-table-optimized.component';
import { PdfViewerComponent } from 'src/app/shared/pdf-viewer/pdf-viewer.component';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { DemandeValidation } from '@models/api/responses';
import { PagedResultDTO } from '@models/shared';
import { DemandesService } from 'src/app/core/services/demandes.service';
import { DemandeStatusService } from 'src/app/core/services/demande-status.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Role } from '@models/enums';
import { RoleService } from 'src/app/core/services/role.service';
@Component({
    selector: 'app-demande-avis-list',
    imports: [MatDividerModule, MatIconModule, MatButtonModule, DataTableOptimizedComponent, ArianeNavComponent],
    templateUrl: './demande-avis-list.component.html',
    styleUrls: ['./demande-avis-list.component.scss'],
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemandeAvisListComponent implements OnInit, OnDestroy {
  @ViewChild('avisTable') avisTable!: DataTableOptimizedComponent;

  arianeLabel: string = "Demandes d'avis";
  arianeIcon: string = 'star_border';
  arianeList = [
    {
      label: "Demandes d'avis",
      url: '/pama/demande-avis-list'
    }
  ];

  demandesDisplayedColumns: string[] = [
    'Emetteur de la demande',
    'Type de demande',
    'Direction',
    'Service',
    'N° de poste',
    'Date de création',
    'Statut',
    'Actions'
  ];

  demandesCellStyleCss: any = {
    Statut: { 'text-align': 'center' },
    'Date création': { 'text-align': 'center' }
  };

  demandesHeaderStyleCss: any = {
    Statut: { display: 'flex', 'justify-content': 'center' }
  };

  private readonly destroy$ = new Subject<void>();
  pipe = new DatePipe('fr-FR');

  constructor(
    private readonly demandesService: DemandesService,
    private readonly dialog: MatDialog,
    private readonly demandeStatusService: DemandeStatusService,
    private readonly cdr: ChangeDetectorRef,
    private readonly notificationService: NotificationService,
    private readonly roleService: RoleService
  ) {}

  ngOnInit(): void {}

  getDemandesAvis = (pageIndex: number, pageSize: number): Observable<PagedResultDTO<DemandeValidation>> => {
    return this.demandesService.getDemandesAvis(pageIndex, pageSize).pipe(
      map((response) => {
        this.cdr.detectChanges();
        return {
          ...response,
          results: this.transformData_demandes(response.results)
        };
      })
    );
  };

  transformData_demandes(demandes: DemandeValidation[]): any[] {
    return demandes.map((demande: any) => ({
      'ID de la demande': demande.id,
      'Emetteur de la demande': demande.emetteur,
      'Type de demande': demande.typeDemande,
      Direction: demande.direction || '',
      Service: demande.serviceFonctionnel || '',
      'N° de poste': demande.numeroPoste || '',
      'Date de création': demande.dateCreation ? this.pipe.transform(demande.dateCreation, 'dd/MM/yyyy HH:mm') : 'Date non définie',
      Statut: {
        text: this.demandeStatusService.getStatusText(demande.statut),
        class: this.demandeStatusService.getStatusClass(demande.statut)
      },
      id: demande.id,
      valider_hidden: true,
      valider_disabled: true,
      refuser_hidden: true,
      refuser_disabled: true,
      view_hidden: true,
      view_disabled: true,
      showAdvice: true,
      statut: demande.statut,
      typeDemande: demande.typeDemande,
      subTable: [],
      actionOrder: ['advice']
    }));
  }

  avisDemande(element: any) {
    this.dialog
      .open(PdfViewerComponent, {
        width: '2000px',
        height: '100%',
        maxWidth: '100vw',
        panelClass: 'dialog-bg-trans',
        data: {
          demandes: [{ id: element.id, type: element.typeDemande }],
          filename: `avis-demande-${element.id}`,
          action: 'advice'
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result === 'refresh') {
          this.avisTable?.refresh();
          this.notificationService.refreshValidationCounts(this.roleService.canAccess([Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR]));
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
